import { Action } from "shared/types/Action"

export enum ActionsOverlayActionType {
  ACTION = "ACTION",
  GROUP = "GROUP",
  BACK = "BACK"
}

export interface ActionsOverlayAction extends Action {
  actionType: ActionsOverlayActionType
}
